import React, { useMemo } from "react";

import { IVenue } from "Venues/types";
import { BaseHeader } from "Venues/components";
import { IActionDropdownItem } from "shared/components";
import { useHistory } from "react-router-dom";
import { getVenueActions, useVenueRoute } from "Venues/utils";
import { useVenueEventContext, useVenuePageContext } from "Venues/contexts";

export const VenueHeader: React.FC<IVenue> = ({ id, ...venueProps }) => {
  const { editBlockUrl } = useVenueEventContext();
  const { pushRoute } = useVenueRoute();

  const {
    openDeleteVenueModal,
    userPermissions,
    openPublishModal,
    openRequestPublishModal,
    openUnpublishModal,
    openSuggestEditModal,
  } = useVenuePageContext();
  const history = useHistory();

  const actions: IActionDropdownItem[] | undefined = useMemo(() => {
    return getVenueActions({
      venueId: id,
      history,
      userPermissions,
      openDeleteVenueModal,
      openPublishModal,
      openRequestPublishModal,
      openUnpublishModal,
      openSuggestEditModal,
      pushRoute,
    });
  }, [
    id,
    history,
    userPermissions,
    openDeleteVenueModal,
    openPublishModal,
    openRequestPublishModal,
    openUnpublishModal,
    openSuggestEditModal,
    pushRoute,
  ]);

  return (
    <BaseHeader
      id={id}
      {...venueProps}
      theme="full"
      actions={actions}
      editBlockUrl={editBlockUrl}
    />
  );
};
